import { config } from "../../../config/config";
import { authHeaders, handleV2Error } from "../_helpers";
import { userProfileSchema, type UserProfile } from "../../../utils/zod/user";

export type { UserProfile };

export interface UpdateUserProfileInput {
  firstName?: string;
  lastName?: string;
  profilePictureKey?: string;
}

export const updateUserProfileRequest = async (
  input: UpdateUserProfileInput,
  token: string,
): Promise<UserProfile> => {
  const response = await fetch(`${config.API_V2_URL}/v2/users/me`, {
    method: "PATCH",
    headers: authHeaders(token),
    body: JSON.stringify(input),
  });

  if (!response.ok) await handleV2Error(response);

  const { data } = await response.json();
  return userProfileSchema.parse(data);
};

export const getUserProfileRequest = async (
  token: string,
): Promise<UserProfile | null> => {
  const response = await fetch(`${config.API_V2_URL}/v2/users/me`, {
    method: "GET",
    headers: authHeaders(token),
  });

  if (response.status === 404) return null;
  if (!response.ok) await handleV2Error(response);

  const { data } = await response.json();
  return userProfileSchema.parse(data);
};
